
import { computed, defineComponent, reactive } from 'vue'

import NewHeader from '@/modules/NewDispatcher/components/NewHeader/index.vue'

import Sidebar from '@/common/components/Sidebar/index.vue'
import ImpersonatePanel from '@/common/components/ImpersonatePanel/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import PreTripCompleteDayModal from '@/modules/TMSModule/components/PreTripCompleteDayModal/index.vue'

import useImpersonate from '@/common/composable/useImpersonate'
import { useRoute } from 'vue-router'
import { useGlobalStore } from '@/store/globalStore'

export default defineComponent({
    components: {
        NewHeader,
        Sidebar,
        ImpersonatePanel,
        TheButton,
        PreTripCompleteDayModal,
    },
    setup() {
        const store = useGlobalStore()
        const { impersonate_state } = useImpersonate(false)
        const route = useRoute()

        const withoutSectors = computed(() => !route.path.includes('/new-dispatcher'))

        const complete_tms_day_state = reactive({
            is_opened: false,
            is_can_complete: false,
        })

        const onCompleteTmsDay = (is_can_complete: boolean) => {
            complete_tms_day_state.is_can_complete = is_can_complete
            complete_tms_day_state.is_opened = true
        }

        const onCompleteTmsDayCancel = () => {
            complete_tms_day_state.is_opened = false
            complete_tms_day_state.is_can_complete = false
        }

        return {
            complete_tms_day_state,
            store,
            impersonate_state,
            withoutSectors,
            onCompleteTmsDay,
            onCompleteTmsDayCancel,
        }
    },
})
